import {dimensionTransformation, v3} from "@alchemiesolns/maths";
import {calcVect, getLargestAngle} from "./utils/BondLpVectorMath";

export const lonePairs2d = {
    /**
     * This is all in the x, y plane.
     * All angles are calculated clockwise.
     * @param bonds an array of vectors
     * @param lps number of lone pairs
     * @return A list of unit vectors in the direction where the lone pairs should be placed
     */
    arrangeLonePairs: (bonds: number[][], lps: number) => {
        // console.log("Arrange Lone Pairs bonds", bonds)
        // console.log("Arrange Lone Pairs lps", lps)
        const basis = {
            normal: [0, 0, 1],
            origin: [0, 0, 0],
            right: [1, 0, 0]
        }
        const pseudoBonds = bonds.map(b => {
            const pos2D = dimensionTransformation.to2dPlanePoint(b, basis);
            return [pos2D[0], pos2D[1]]
        })

        const lp2DVects: number[][] = [];

        // get the largest uninterrupted angle and starting vector
        // let {largestAngle, startVect} = getLargestAngle(pseudoBonds);
        let {largestAngle, startVect} = getLargestAngle(pseudoBonds);

        if (bonds.length === 0) {
            const angle = Math.PI * 2.0 / lps;
            for (let i = 0; i < lps; i++) {
                lp2DVects.push(calcVect(startVect, angle * (i + 1)));
            }
        } else if (bonds.length === 2 && largestAngle > 175 * Math.PI / 180 && largestAngle < 185 * Math.PI / 180 && (lps === 3 || lps === 4)) { // if linear with 3 or 4 lps
            if (lps === 3) {
                lp2DVects.push(calcVect(startVect, Math.PI / 3.0));
                lp2DVects.push(calcVect(startVect, 2.0 * Math.PI / 3.0));
                lp2DVects.push(calcVect(startVect, 3.0 * Math.PI / 2.0));
            } else {
                lp2DVects.push(calcVect(startVect, Math.PI / 3.0));
                lp2DVects.push(calcVect(startVect, 2.0 * Math.PI / 3.0));
                lp2DVects.push(calcVect(startVect, 4.0 * Math.PI / 3.0));
                lp2DVects.push(calcVect(startVect, 5.0 * Math.PI / 3.0));
            }
        } else if (bonds.length === 1 || largestAngle > 185 * Math.PI / 180) {
            const angle = largestAngle / (lps + 1);
            for (let i = 0; i < lps; i++) {
                lp2DVects.push(calcVect(startVect, angle * (i + 1)));
            }
        } else {
            for (let i = 0; i < lps; i++) {
                if (i >= 1) { // if not the first lone pair, recalculate the largest angle.
                    const d = getLargestAngle(pseudoBonds);
                    largestAngle = d.largestAngle;
                    startVect = d.startVect;
                }
                const newVect = calcVect(startVect, largestAngle / 2.0);
                lp2DVects.push(newVect);
                pseudoBonds.push(newVect);
            }
        }

        const lp3DVects: number[][] = [];

        lp2DVects.map(v => lp3DVects.push(v3.normalize(dimensionTransformation.to3dPoint([v[0], v[1]], basis))));
        return lp3DVects;
    }
}